import { createContext } from 'react';

import { sessionConfig } from './constant';

// ** Third Party Components
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import PicDispose from 'assets/images/layer-enhancement/pic_dispose.png';

// import withReactContent from 'sweetalert2-react-content';

import UserAccessService from 'services/userAccess';
import isJwtTokenExpired, { decode } from 'jwt-check-expiry';
import { Route } from 'react-router-dom';

import _axios from 'axios';
import moment from 'moment';
import i18n from 'i18nConfig';
import CryptoJS from 'crypto-js';
import { Buffer } from 'buffer';
import * as FileSaver from 'file-saver';
import packageJson from '../../package.json';

import '../utils/sweetAlert2.css';
import PicError from 'assets/images/layer-enhancement/pic_error.png';

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num) => {
  return num > 999 ? `${(num / 1000).toFixed(1)}k` : num;
};

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, '');

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value;
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value));
};

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: 'short', day: 'numeric' };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' };
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value));
};

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => {
  const accessToken = JSON.parse(localStorage.getItem(sessionConfig.storageTokenKeyName));
  return !_.isEmpty(localStorage.getItem(sessionConfig.userData)) && accessToken && !isJwtTokenExpired(accessToken);
};

export const getUserData = () => JSON.parse(localStorage.getItem(sessionConfig.userData));
export const getAccessToken = () => JSON.parse(localStorage.getItem(sessionConfig.storageTokenKeyName));
export const getProject = () => JSON.parse(localStorage.getItem(sessionConfig.project));
export const getProducts = () => JSON.parse(localStorage.getItem(sessionConfig.products));
export const getProduct = () =>
  localStorage.getItem(sessionConfig.product) !== 'undefined' && JSON.parse(localStorage.getItem(sessionConfig.product));

export const getUserProjSection = () => {
  //
  //
  if (localStorage.getItem(sessionConfig.userData) !== null) {
    const user = JSON.parse(localStorage.getItem(sessionConfig.userData));
    const decode_token = decode(user.accessToken);

    // return [];
    return JSON.parse(decode_token.payload?.UserProjSection);
  }
  return [];
};

export const getUserRole = () => {
  if (localStorage.getItem(sessionConfig.userData) !== null) {
    const user = JSON.parse(localStorage.getItem(sessionConfig.userData));
    const decode_token = decode(user.accessToken);

    return decode_token.payload.Permission;
  }
  return [];
};

export const canAccessPage = (props) => {
  const menuData = UserAccessService.getMenuData();

  if (localStorage.getItem(sessionConfig.userData) !== null) {
    const result = UserAccessService.getSectionLists({
      lang: props.lang,
      SubContCode: props.SubContCode
    });

    const routeInList = menuData.filter((item) => {
      if (item.navLink === props.path) {
        return true;
      }
    });

    if (routeInList.length === 0) {
      return true;
    }

    const user_access_menu = result.filter((item) => {
      if (item.navLink === props.path) {
        return true;
      }
    });

    if (user_access_menu.length > 0) {
      return true;
    } else {
      return false;
    }
  }
};

export const checkBeforeCb = (condition, cb = () => { }) => {
  if (condition) {
    if (cb) cb();
    return;
  }
  return;
};

/**

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = () => {
  return '/';
};

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
});

export const MySwal = withReactContent(Swal);

export const handleAlertMessage = ({ icon, title, cb, ...rest }) => {
  //disable default title and icon
  return MySwal.fire({
    // title: i18n.t('DIALOG_RESULT'),
    title: title,
    // icon, // 'success',
    icon: icon,
    customClass: {
      confirmButton: 'btn btn-success me-1',
      cancelButton: 'btn btn-danger me-1',
      popup: 'popup popup-alert'
    },
    confirmButtonColor: '#5ec4a2',
    cancelButtonColor: '#fff',
    showConfirmButton: true,
    showCancelButton: true,
    cancelButtonText: i18n.t('NO'),
    // confirmButtonText: 'OK', //button text
    confirmButtonText: i18n.t('OK'), //button text
    buttonsStyling: true,
    reverseButtons: true,
    ...rest
  }).then(cb);
};

export const axios = _axios.create({
  baseURL: process.env.REACT_APP_WEB_API_URL,
  validateStatus: () => true
});

const updateDateFields = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(updateDateFields);
    }

    if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj).reduce((acc, key) => {
            const value = obj[key];

            if (key.includes('Date')) {
                if (Array.isArray(value)) {
                    // Handle filtering date ranges
                    if (value.length === 2 && value[0]?.includes('-')) {
                        // Set the second date to end of day
                        value[1] = `${value[1].substring(0, 11)} 23:59:59`;
                        acc[key] = value.map(i => formatDateString(i));
                    } else {
                        acc[key] = value.map(i => formatDateString(i));
                    }
                } else {
                    acc[key] = formatDateString(value);
                }
            } else {
                // Recursively handle nested objects
                acc[key] = updateDateFields(value);
            }

            return acc;
        }, {});
    }

    return obj; // Return the original value if not an object
};

const formatDateString = (dateString) => {
    // Handle valid date strings: Check for formats based on length and content
    if (typeof dateString === 'string' && dateString.includes('-')) {
        const date = moment(dateString.length === 10 ? `${dateString} 00:00:00` : dateString, 'DD-MM-YYYY HH:mm:ss');

        if (date.isValid()) {
            return date.format('YYYY-MM-DD HH:mm:ss'); // Change format as needed
        }
    }
    return dateString; // Return original if it's not a valid date
};

axios.interceptors.request.use((config) => {
  if (config.data) {
    config.data = updateDateFields(config.data);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const toDefaultDateFormat = (date, showTime) => {
  const newDate = moment(new Date().toUTCString());
  return date ? moment(date || newDate).format(showTime ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY') : '';
};

export const toDefaultMicDateFormat = (date) => {
  return toDefaultDateFormat(date, true);
};

export const AppContext = createContext();

const exceptionHandling = ({ errorMsg, response, cb }) =>
  handleAlertMessage({
    title: i18n.t('ERROR_MESSAGE'),
    text: i18n.t(errorMsg),
    icon: 'error',
    // imageUrl: PicDispose,
    showCancelButton: false,
    cb: () => {
      if (cb) cb(response);
    }
  });

//testing error message handling
export const errorHandling = () => {
  return handleAlertMessage({
    imageUrl: PicError,
    showCancelButton: false,
    title: i18n.t('ERROR_MESSAGE'),
    cb: () => {
      if (cb) cb(response);
    }
  });
};

export const clearLocalStorage = () => {
  if ('caches' in window) {
    caches.keys().then((names) => {
      // Delete all the cache files
      names.forEach((name) => {
        caches.delete(name);
      });
    });

    // Makes sure the page reloads. Changes are only visible after you refresh.
    window.location.reload(true);
  }
};

export const versionCheckAndRefresh = () => {
  const version = localStorage.getItem(sessionConfig.version);

  if (!version) {
    localStorage.setItem(sessionConfig.version, packageJson.version);
    return;
  }

  if (version !== packageJson.version) {
    if ('caches' in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });

      // Makes sure the page reloads. Changes are only visible after you refresh.
      window.location.reload(true);
    }

    // localStorage.clear()
    localStorage.setItem(sessionConfig.version, packageJson.version);
  }
};

export const handleAsyncCall = async ({
  service,
  params,
  successCb = () => { },
  otherErrorCb,
  systemErrorCb,
  rejectWithValue = (msg) => msg,
  setDetailBlock = () => { },
  cusExceptionHandle,
  showSuccessAlert,
  t = i18n.t
}) => {
  versionCheckAndRefresh();
  setDetailBlock(true);
  let errorMsg;
  const _params = params instanceof Array ? params : [params];
  try {
    const response = await service(..._params);
    const resData = response.data;

    if (String(response.status).startsWith(2)) {
      setDetailBlock(false);

      if (showSuccessAlert) {
        handleAlertMessage({
          text: t('SUCCESS'),
          icon: 'success',
          showCancelButton: false,
          cb: () => {
            successCb(response);
          }
        });
      } else {
        successCb(response);
      }

      return resData || response;
    } else {
      errorMsg = resData?.Message || resData?.message;

      if (cusExceptionHandle) {
        cusExceptionHandle(response);
      } else {
        exceptionHandling({
          errorMsg,
          response,
          cb: otherErrorCb
        });
      }
      setDetailBlock(false);

      throw rejectWithValue(errorMsg);
    }
  } catch (error) {
    const errorResponse = error?.response;
    const errorData = errorResponse?.data;
    if (String(errorResponse?.status).startsWith(4) || String(errorResponse?.status).startsWith(5)) {
      errorMsg = errorData?.Message || errorData?.message;
      if (cusExceptionHandle) {
        cusExceptionHandle(errorResponse);
      } else {
        exceptionHandling({
          errorMsg,
          response: errorResponse,
          cb: systemErrorCb
        });
      }

      setDetailBlock(false);
    }
    throw rejectWithValue(errorMsg);
  }
};

export const mapListToOptions = (list = [], labelKey, valueKey, ...rest) => {
  return list?.map((obj) => {
    const newOption = { label: obj[labelKey], value: obj[valueKey] };

    rest?.forEach((key) => {
      newOption[key] = obj[key];
    });
    return newOption;
  });
};

export const mapOptionsToList = (list = [], labelKey, valueKey, ...rest) => {
  return list?.map((obj) => {
    const newOption = { [labelKey]: obj.label, [valueKey]: obj.value };

    rest?.forEach((key) => {
      newOption[key] = obj[key];
    });
    return newOption;
  });
};

export const addAllToOptions = (t, options = []) => {
  return options.concat([
    {
      label: t('ALL'),
      value: '*'
    }
  ]);
};

export const mapNullValueToMtyString = (obj) => {
  if (_.isObject(obj) && !_.isArray(obj)) {
    const objEntries = Object.entries(obj);

    const mapObjEntries = objEntries.map(([key, value]) => {
      // if (value === null) {
      //     return [key, '']
      // }

      if (_.isObject(value) && !_.isArray(value)) {
        Object.entries(value);
        const objEntries2 = Object.entries(value);

        const mapObjEntries2 = objEntries2.map(([key2, value2]) => {
          if (value2 === null) {
            return [key2, ''];
          }
          return [key2, value2];
        });

        return [key, Object.fromEntries(mapObjEntries2)];
      }
      return [key, value];
    });

    return Object.fromEntries(mapObjEntries);
  }

  return obj;
};

export const useLocalStorage = () => {
  return {
    setStorage: (key, value) => window.localStorage.setItem(key, JSON.stringify(value)),
    getStorage: (key) => {
      const item = window.localStorage.getItem(key) || null;
      return item && item !== 'undefined' ? JSON.parse(item) : {};
    },
    removeStorage: (key) => window.localStorage.removeItem(key)
  };
};

export const aesEncrypt = (password = '') => {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_KEY);
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_IV);
  const encrypted = CryptoJS.AES.encrypt(password, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.toString();

  // const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
  //     iv,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7
  // })
  //
};

export const transferPdfBufferToSrc = (buffer) => {
  const base64ImageString = Buffer.from(buffer, 'binary').toString('base64');

  return `data:application/pdf;base64,${base64ImageString}`;
};

// export const downloadExcel = (excelBuffer, fileName = 'abc') => {
//   const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//   const fileExtension = '.xlsx';
//   const data = new Blob([excelBuffer], { type: fileType });

//   FileSaver.saveAs(data, fileName + fileExtension);
// };

export const downloadExcel = (excelBuffer, fileName = 'abc') => {
  // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const data = new Blob([excelBuffer]);

  FileSaver.saveAs(data, fileName + fileExtension);
};

export const download = (src, fileName = 'abc.pdf') => {
  const linkSource = src;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

export const OptionUtils = {
  localizeCategoryOptions: (data, upperCaseLang) =>
    data.map(({ Category, ...rest }) => ({
      label: rest[`Desc${upperCaseLang}`],
      value: Category,
      ...rest
    })),
  localizeBctypeOptions: (data, upperCaseLang) =>
    data.map(({ Bctype, ...rest }) => ({ label: rest[`Desc${upperCaseLang}`], value: Bctype })),
  mapRegionFloorOptions: (data) => data.map(({ Key, Value }) => ({ label: Key, value: Value })),
  mapRoomOptionsFromLocations: (data) => data.map(({ Room, RoomId }) => ({ label: Room, value: RoomId })),
  mapFloorOptionsFromLocations: (data) => data.map(({ Floor }) => ({ label: Floor, value: Floor })),
  mapRegionOptionsFromLocations: (data) => data.map(({ Region }) => ({ label: Region, value: Region }))
};

export const isConstructor = (f) => {
  try {
    new f();
  } catch (err) {
    if (err.message.indexOf('is not a constructor') >= 0) {
      return false;
    }
  }
  return true;
};
